import { render, staticRenderFns } from "./message.vue?vue&type=template&id=be48ee04&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style1 from "./message.vue?vue&type=style&index=1&id=be48ee04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be48ee04",
  null
  
)

export default component.exports